var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 24,
    viewBox: "0 0 13 24",
    fill: "fff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1699 24C11.0383 24.0007 10.9078 23.9755 10.786 23.9257C10.6641 23.876 10.5533 23.8027 10.4599 23.71L2.28989 15.54C1.82426 15.0755 1.45483 14.5238 1.20277 13.9163C0.950701 13.3089 0.820953 12.6577 0.820953 12C0.820953 11.3423 0.950701 10.6911 1.20277 10.0837C1.45483 9.4762 1.82426 8.92445 2.28989 8.45999L10.4599 0.290002C10.5531 0.196764 10.6638 0.122803 10.7856 0.0723425C10.9075 0.0218822 11.038 -0.00408935 11.1699 -0.00408936C11.3018 -0.00408936 11.4323 0.0218822 11.5541 0.0723425C11.676 0.122803 11.7867 0.196764 11.8799 0.290002C11.9731 0.38324 12.0471 0.49393 12.0976 0.615752C12.148 0.737574 12.174 0.868142 12.174 1C12.174 1.13186 12.148 1.26243 12.0976 1.38425C12.0471 1.50607 11.9731 1.61676 11.8799 1.71L3.70989 9.87999C3.14809 10.4425 2.83253 11.205 2.83253 12C2.83253 12.795 3.14809 13.5575 3.70989 14.12L11.8799 22.29C11.9736 22.3829 12.048 22.4935 12.0988 22.6154C12.1496 22.7373 12.1757 22.868 12.1757 23C12.1757 23.132 12.1496 23.2627 12.0988 23.3846C12.048 23.5064 11.9736 23.617 11.8799 23.71C11.7865 23.8027 11.6756 23.876 11.5538 23.9257C11.432 23.9755 11.3015 24.0007 11.1699 24Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/left_icon.626ca8b0ab8bdca8e12c878435b0b2fe.svg";
export { ForwardRef as ReactComponent };